import * as Constants from '../constants/';

export default function(state = {}, action) {
  switch (action.type) {
    case Constants.OPEN_MODAL:
      return {
        ...state,
        [action.modal]: {
          isOpen: true,
          data: action.data
        }
      };
    case Constants.CLOSE_MODAL:
      return {
        ...state,
        [action.modal]: {
          isOpen: false
        }
      };
    case Constants.UPDATE_MODAL:
      return {
        ...state,
        [action.modal]: {
          isOpen: state[action.modal] && state[action.modal].isOpen,
          data: {
            ...(state[action.modal] && state[action.modal].data),
            ...action.data
          }
        }
      };
    default:
      return state;
  }
}
